function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "2 2 16 16"
}, props), React.createElement("path", {
  d: "M16 3.71a.62.62 0 00-.55 0L3.99 9.41a.62.62 0 00.28 1.17h5.15l-.02 5.15a.62.62 0 001.17.28l5.7-11.47a.62.62 0 00-.27-.83z"
})));